<template>
  <PublicPageTemplate>
    <template v-slot:content>
      <TWLoadingSpinner v-if="loading" />
      <PublicPageHeader :title="$t('reset.pageTitle')" />
      <div class="mb-sm">
        <span>
          {{ $t('reset.emailAddress') }}
          <b>{{ email }}</b>
        </span>
      </div>
      <form @submit.prevent="validateForm">
        <FloatingLabelInput
            type="password"
            @input="clearPasswordErrorMessage"
            v-model="password"
            :has-error="passwordErrorMessage"
            :placeholder="$t('reset.newPassword')"
            v-validate="validation.password"
            data-vv-name="password"
            :data-vv-as="$t('reset.passwordLC')"
            data-vv-scope="reset"
            data-test="reset-password"
            data-hj-suppress
            data-ec="reset_password_account"
            data-et="new_password_input"
        />
        <PublicPageValidationError :errorMessage="passwordErrorMessage" />
        <PublicPageSubmitButton
            :text="$t('reset.cta')"
            data-test="reset-button"
            data-ec="reset"
            data-et="reset_button"
        />
      </form>
    </template>
  </PublicPageTemplate>
</template>

<script>
import { mapActions } from 'vuex';
import { EventBus } from '@/utils/event-bus';
import validation from '@/utils/validation';
import TWLoadingSpinner from '@/components/tailwind/LoadingSpinner.vue';
import PublicPageTemplate from '@/components/tailwind/publicPages/PublicPageTemplate.vue';
import PublicPageHeader from '@/components/tailwind/publicPages/PublicPageHeader.vue';
import FloatingLabelInput from '@/components/tailwind/forms/FloatingLabelInput.vue';
import PublicPageSubmitButton from '@/components/tailwind/publicPages/PublicPageSubmitButton.vue';
import PublicPageValidationError from '@/components/tailwind/publicPages/PublicPageValidationError.vue';


export default {
  name: 'ResetPassword',
  inject: {
    $validator: '$validator',
  },
  components: {
    FloatingLabelInput,
    TWLoadingSpinner,
    PublicPageTemplate,
    PublicPageHeader,
    PublicPageSubmitButton,
    PublicPageValidationError,
  },
  data() {
    return {
      validation,
      passwordErrorMessage: null,
      email: this.$route.query.email || null,
      password: null,
      loading: false,
      submitted: false,
      appV1Url: process.env.VUE_APP_APPV1,
    };
  },
  methods: {
    ...mapActions('user', [
      'RESET_PASSWORD',
    ]),
    clearPasswordErrorMessage() {
      this.passwordErrorMessage = null;
    },
    async validateForm() {
      const validated = await this.$validator.validateAll('reset');

      if (!validated) {
        this.passwordErrorMessage = this.errors.items[0].msg;
        return;
      }
      this.loading = true;
      this.RESET_PASSWORD({
        resetToken: this.$route.params.resetToken,
        email: this.email,
        password: this.password,
      }).then(async () => {
          EventBus.$emit('renderGlobalMessage', {
            message: this.$t('reset.success'),
            icon: 'check',
            type: 'success',
          });
          await this.$router.push('/login');
          this.$validator.reset();
          this.submitted = true;
          this.email = '';
          this.password = '';
        }).finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
